/**
 * UsuariosEstadual.tsx — Gestão de equipe do painel estadual.
 * Usa o componente genérico EquipeManager com ESTADUAL_CONFIG.
 */
import { EquipeManager, buildEstadualConfig } from '../../components/equipe';
import { useAuthStore } from '../../store/authStore';

export function UsuariosEstadual() {
  const estadoId = useAuthStore((s) => s.user?.estadoId);

  if (!estadoId) {
    return (
      <div className="admin-page" style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>
        Nenhum estado vinculado ao seu perfil.
      </div>
    );
  }

  return <EquipeManager config={buildEstadualConfig(estadoId)} />;
}
